/* Magnifissance 2026 — global scripts */
(function () {
  'use strict';

  // Add-to-cart and the cart count live in assets/cart-drawer.js.

  // Product thumbnail → main image swap
  document.addEventListener('click', function (e) {
    const thumb = e.target.closest('.product__thumb');
    if (!thumb) return;
    const main = document.querySelector('.product__image');
    if (main && thumb.currentSrc) main.src = thumb.currentSrc;
  });

  // Header "Shop" mega menu — hover to open, hover left category to switch columns
  document.querySelectorAll('.hv5').forEach(function (header) {
    const trigger = header.querySelector('[data-mega-trigger]');
    const mega = header.querySelector('.hv5-mega');
    if (!trigger || !mega) return;

    let timer;
    const link = trigger.querySelector('a');
    const setOpen = function (open) {
      clearTimeout(timer);
      if (open) {
        mega.querySelectorAll('template[data-mega-video]').forEach(function (tpl) {
          tpl.replaceWith(tpl.content.cloneNode(true));
        });
      }
      header.setAttribute('data-mega-open', open ? 'true' : 'false');
      if (link) link.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    const open = function () { setOpen(true); };
    const closeSoon = function () { clearTimeout(timer); timer = setTimeout(function () { setOpen(false); }, 150); };

    [trigger, mega].forEach(function (el) {
      el.addEventListener('mouseenter', open);
      el.addEventListener('mouseleave', closeSoon);
    });
    trigger.addEventListener('focusin', open);
    header.addEventListener('focusout', function (e) {
      if (!header.contains(e.relatedTarget)) setOpen(false);
    });

    // Left category → column panel switching
    const cats = mega.querySelectorAll('.hv5-cat');
    const panels = mega.querySelectorAll('.hv5-mega-panel');
    const activate = function (idx) {
      cats.forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-cat-index') === idx); });
      panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-cat-index') === idx); });
    };
    cats.forEach(function (cat) {
      const idx = cat.getAttribute('data-cat-index');
      cat.addEventListener('mouseenter', function () { activate(idx); });
      cat.addEventListener('focus', function () { activate(idx); });
    });
  });

  // Escape closes any open mobile drawer / mega menu
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.hv5[data-nav-open="true"], .hv5[data-mega-open="true"]').forEach(function (h) {
      h.setAttribute('data-nav-open', 'false');
      h.setAttribute('data-mega-open', 'false');
      const b = h.querySelector('.hv5-burger');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  });
})();
